function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5,8 C14.119,8 13,6.881 13,5.5 C13,4.119 14.119,3 15.5,3 C16.881,3 18,4.119 18,5.5 C18,6.881 16.881,8 15.5,8 M17.538,18 L11.799,18 C11.582,18 11.475,17.738 11.628,17.586 L13.157,16.063 L14.769,14.342 C14.948,14.175 15.24,14.175 15.421,14.342 L17.864,17.271 C18.154,17.54 17.949,18 17.538,18 M9.14,18 L2.67,18 C1.986,18 1.781,17.245 2.265,16.804 L7.289,11.666 C7.589,11.393 8.074,11.393 8.374,11.666 L11.8,15.205 C11.895,15.3 11.895,15.453 11.8,15.548 L9.481,17.858 C9.391,17.949 9.268,18 9.14,18 M18,0 L2,0 C0.896,0 0,0.896 0,2 L0,18 C0,19.104 0.896,20 2,20 L18,20 C19.104,20 20,19.104 20,18 L20,2 C20,0.896 19.104,0 18,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/images.f9f15d01.svg";
export { SvgComponent as ReactComponent };